import React from 'react';
import loadable from '@loadable/component';

const SquareFootageFilter = loadable(
  () =>
    import(
      /* webpackChunkName: "SquareFootageFilter.loadable" */ 'app/shared/modules/MobileSRP/Header/FilterModules/SquareFootageFilter/component'
    ),
);

class LoadableSquareFootageFilter extends React.Component {
  render() {
    return <SquareFootageFilter {...this.props} />;
  }
}

export default LoadableSquareFootageFilter;
